export const DOC_LINKS = {
    OUTSTAFF_ACCESS: 'https://docs.yandex-team.ru/cloud/wiki/page-management/access-setup#outstaff',
    XST: 'https://docs.yandex-team.ru/cloud/wiki/office365/cross-site-tracking',
    MS_OFFICE: 'https://docs.yandex-team.ru/cloud/wiki/office365/ms-office',
    MS_OFFICE_ACCESS_SETTINGS: 'https://docs.yandex-team.ru/cloud/wiki/office365/doc-access',
};
